

import { curry } from 'ramda';
import { on, stream, merge, scan } from 'flyd';
import every from 'flyd/module/every';
import Events from '~/events';
import { dataToTag } from './statistics';
// import { getEventHandlers } from './app-events';

import { getStatus } from './status';
import { data } from './tags.json';


// sendHeartbeat :: Fetch -> Log -> Payload -> Promise
//    Log = ... -> void
//    Payload = { imdHash: String,
//                events: [Event],
//                status: Status }
export const sendHeartbeat = curry(
  (fetch, log, payload) =>
    fetch('/analytics', {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(payload)
    })
      .catch(err => {
        log(err);
        throw { action: 'send heartbeat', label: 'network failure' };
      })
      .then(response => {
        if (!response.ok) {
          log(`Failed send to IMD status. ${response.status} ${response.statusText}`);
          throw { action: 'send heartbeat', label: 'response failure' };
        }
        return response;
      })
);

// heartbeat :: Int -> Stream
const hearbeat = (interval = 1000 * 60 * 5) => every(interval);

// followHeartbeat :: (AppContext, StatusResolver, Pulse, Streams) -> void
const followHeartbeat = (
  context,
  statusResolver,
  { heartbeat$, send },
  { appEvent$, eventsQueue$, loopbackEvent$, _clientId$ } ) =>
  on(_ => {
    Events.dispatchEvent('app:send:analytics');
    const eventsToBeSent = eventsQueue$();
    appEvent$([]);
    statusResolver(context)
      .then(status => send({
        imdHash: context.imdHash,
        events: eventsToBeSent,
        status,
        time: new Date().toISOString(),
      }))
      .then(_ => {
        Events.dispatchEvent('app:online');
      })
    // On error return events back to queue with error
      .catch(err => {
        const newEvents = eventsQueue$();
        const combined = eventsToBeSent.concat(newEvents);
        loopbackEvent$(combined);
        Events.dispatchEvent('app:offline', err);
        Events.dispatchEvent('error:heartbeat', err);
      });
  }, heartbeat$);


// initMain :: (AppContext, [Tag], Body, Pulse, StatusResolver) -> Streams
//    AppContext = { imdHash: String,
//                   events: Events }
//    Body = HtmlElement
//    Pulse = { heartbeat$: Stream,
//              send: Fetch -> Log -> [Event] -> Promise }
//    StatusResolver = AppContext -> Promise Status
//    Streams = { clientId$: Stream,
//                appEvent$: Stream,
//                event$: Stream,
//                eventsQueue$: Stream }
export const initMain = (
  context,
  tags,
  body,
  { heartbeat$ = hearbeat(),
    send = sendHeartbeat(fetch, console.error)
  },
  statusResolver
) => {

  const idleClientId = `${context.imdHash}_idle`;
  const clientId$ = stream(idleClientId);

  const uiEvent$ = stream();
  const appEvent$ = stream();
  const loopbackEvent$ = stream();

  const event$ = merge(merge(uiEvent$, appEvent$), loopbackEvent$);
  const eventsQueue$ = scan((acc, event) => {
    return Array.isArray(event) ? event : // See heartbeat failure (events are returned back)
      event ? acc.concat(event) :    // Append new heartbeat
        [event];
  }, [], event$);

  // const getClientId = () => ({ clientId: clientId$() });

  // const appEventHandlers = getEventHandlers({
  //   context,
  //   appEvent$,
  //   clientId$,
  //   heartbeat$,
  //   toEvent,
  //   idleClientId
  // });

  // const handleUIEvent = pipe(
  //   uiEventToEvent(tags),
  //   map(event => Object.assign(event, getClientId())),
  //   forEach(uiEvent$)
  // );

  // // Capturing user events
  // ['click', 'touch'].forEach(type => body.addEventListener(type, handleUIEvent, true));

  // Object.entries(appEventHandlers).forEach(([type, handler]) =>
  //   Events.addEventListener(type, handler)
  // );

  // Start following heartbeat only after app start
  Events.once('app:start',
    () => followHeartbeat(
      context, statusResolver,
      { heartbeat$, send },
      { appEvent$, eventsQueue$, loopbackEvent$, clientId$ }
    )
  );

  // if (context.devMode) {
  //   flyd.on(event => console.log(event), appEvent$);
  //   flyd.on(event => console.log(event), uiEvent$);
  // }

  return {
    clientId$,
    appEvent$,
    event$,
    eventsQueue$
  };
};

export const init = (context) => {

  const tags = data.map(dataToTag);
  const body = document.querySelector('body');

  initMain(context, tags, body, {}, getStatus);
};

